import dynamic from 'next/dynamic';
import { ClubSignupSpotProps } from './club-signup-spot';

export const ClubSignupSpot = dynamic<ClubSignupSpotProps>(
    () => import('./club-signup-spot').then((mod) => mod.ClubSignupSpot),
    {
        ssr: false,
    }
);
